import React, { useEffect, useState } from "react";
import moment from "moment";
import { getUnits, getFamilies } from "./action";
import { connect } from "react-redux";
import { Panel, PanelHeader } from "../Panel";
import { Filter } from "./Filter";
import { DateRangeConfig } from "./config";

import PanelTitle from "components/PanelTitle";
import LoadingComponent from "components/LoadingComponent";

const defaultValueText = {
  value: -1,
  text: "",
};

const defaultState = {
  family: defaultValueText,
  type: defaultValueText,
  version: defaultValueText,
  dateRange: {
    value: DateRangeConfig.DEFAULT_DATERANGE,
  },
};

export const famOption = {
  FAMILY_UNITS: "familyUnits",
  FAMILY_PACKAGES: "familyPackages",
};

function Filters({
  className,
  initialValues,
  hasFamily,
  hasType,
  hasVersion,
  hasDateRange,
  dateRangeFilterTitle,
  onFilterValueChange,
  familyOption,
  isAdvanceDateFilter = false,
  hasSearched,
  roleNameId,
  ...props
}) {
  const [familiyOptions, setFamiliyOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (roleNameId && familyOption && familyOption == famOption.FAMILY_UNITS) {
      props.getUnits(roleNameId).then((resp) => {
        setFamiliyOptions(resp);
        setIsLoading(false);
      });
    } else if (roleNameId && familyOption && familyOption == famOption.FAMILY_PACKAGES) {
      props.getFamilies(roleNameId).then((result) => {
        result = [{productId: -1, productName: "-"}, ...result]
        setFamiliyOptions(result);
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }, []);

  const { selectedFilters, handleChange, options } = useFilter(
    familiyOptions,
    initialValues,
    onFilterValueChange,
    familyOption
  );

  const children = React.Children.map(props.children, (child) =>
    React.cloneElement(child, { onChange: handleChange })
  );

  return (
    <div className={className}>
      <Panel>
        <LoadingComponent isLoading={isLoading}>
          <PanelHeader>
            <PanelTitle bold title="Filter List" />
          </PanelHeader>
          {hasDateRange && (
            <Filter
              isDateRangeFilter
              isAdvanceDateFilter={isAdvanceDateFilter}
              name="dateRange"
              title={dateRangeFilterTitle ? dateRangeFilterTitle : "Date"}
              value={selectedFilters.dateRange.value}
              onChange={handleChange}
              hasSearched={hasSearched}
            />
          )}
          {hasFamily && (
            <Filter
              name="family"
              title="Family"
              options={options.families}
              value={selectedFilters.family.value}
              onChange={handleChange}
            />
          )}
          {hasType && (
            <Filter
              name="type"
              title="Type"
              options={options.types}
              value={selectedFilters.type.value}
              onChange={handleChange}
            />
          )}
          {hasVersion && (
            <Filter
              name="version"
              title="Version"
              options={options.versions}
              value={selectedFilters.version.value}
              onChange={handleChange}
            />
          )}
          {children}
        </LoadingComponent>
      </Panel>
    </div>
  );
}

const mapDispatchToProps = {
  getUnits,
  getFamilies,
};

export default connect(() => {}, mapDispatchToProps)(Filters);

const useFilter = (units, initialValues, onFilterValueChange, familyOption) => {
  const values = { ...defaultState, ...initialValues };

  const [selectedFilters, setSelectedFilters] = useState(values);
  const families =
    familyOption && familyOption == famOption.FAMILY_PACKAGES
      ? units.map((unit) => {
          return { id: unit.productId, name: unit.productName };
        })
      : units.map((unit) => unit.unit_family);

  const types =
    familyOption && familyOption == famOption.FAMILY_PACKAGES
      ? []
      : families
          .filter((family) => family.id === selectedFilters.family.value)
          .flatMap((family) => family.unit_types);
  const versions =
    familyOption && familyOption == famOption.FAMILY_PACKAGES
      ? []
      : types
          .filter((type) => type.id === selectedFilters.type.value)
          .flatMap((type) => type.unit_versions);

  function handleChange(e, picker) {
    const name = e.target.name;

    if (name === DateRangeConfig.ADV_ACTIONS.dateFilterReset) {
      setSelectedFilters({
        ...selectedFilters,
        dateRange: {
          value: {
            startDate: DateRangeConfig.DEFAULT_DATERANGE.startDate,
            endDate: DateRangeConfig.DEFAULT_DATERANGE.endDate,
          },
        },
      });
    } else if (name === DateRangeConfig.ADV_ACTIONS.dateFilterAlltime) {
      setSelectedFilters({
        ...selectedFilters,
        dateRange: {
          value: {
            startDate: DateRangeConfig.ALLTIME_DATERANGE.startDate,
            endDate: DateRangeConfig.ALLTIME_DATERANGE.endDate,
          },
        },
      });
    } else if (picker) {
      const startDate = moment(picker.startDate).format("L");
      const endDate = moment(picker.endDate).format("L");
      setSelectedFilters({
        ...selectedFilters,
        dateRange: {
          value: {
            startDate,
            endDate,
          },
        },
      });
    } else if (name === "family") {
      setSelectedFilters({
        ...selectedFilters,
        type: defaultValueText,
        version: defaultValueText,
        [name]: {
          value: parseInt(e.target.value),
          text: e.target[e.target.selectedIndex].text,
        },
      });
    } else if (name === "type") {
      setSelectedFilters({
        ...selectedFilters,
        version: defaultValueText,
        [name]: {
          value: parseInt(e.target.value),
          text: e.target[e.target.selectedIndex].text,
        },
      });
    } else {
      setSelectedFilters({
        ...selectedFilters,
        [name]: {
          value: parseInt(e.target.value),
          text: e.target[e.target.selectedIndex].text,
        },
      });
    }
  }

  useEffect(() => {
    if (selectedFilters !== values) {
      onFilterValueChange(selectedFilters);
    }
  }, [selectedFilters]);

  return {
    selectedFilters,
    handleChange,
    options: { families, types, versions },
  };
};
